import { render, staticRenderFns } from "./o-article-v3.vue?vue&type=template&id=3a699284&scoped=true"
import script from "./o-article-v3.vue?vue&type=script&lang=js"
export * from "./o-article-v3.vue?vue&type=script&lang=js"
import style0 from "./o-article-v3.vue?vue&type=style&index=0&id=3a699284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a699284",
  null
  
)

export default component.exports